import websiteImg1 from '../assets/ecommerce-websites.jpg' ;
import websiteImg2 from '../assets/food-ecommerce.jpg' ;

export default function Projects () {

    const config = {
        projects : [
            {
                image : websiteImg1,
                description : 'A e-commerce website, Shopkart, which is a Django based e-commerce platform with user authentication and many more features.',
                link : 'https://github.com/VSudharson/E-commerce-website---Shopkart'
            },
            {
                image : websiteImg2,
                description : 'A user friendly simple food e-commerce website, Foodcart, which is built with React Js.',
                link : 'https://foodcart-woad.vercel.app/'
            },
            //{
            //    image : websiteImg3,
            //    description : 'A simple blog website. Users can view many areas for their travel purpose.',
            //    link : ''
            //}
        ]
    }
    return <section className="flex flex-col py-10 px-5 justify-center bg-primary text-white" id='projects'>
        <div className="w-full">
            <div className="flex flex-col px-10 py-10">
                <h1 className="text-4xl border-b-4 border-secondary mb-5 w-[140px] font-bold">Projects</h1>
                <p>These are some of my best projects. I have built these with <span className='font-bold'>HTML, CSS, JavaScript, Bootstrap, React JS, Python, MySQL and Django.</span> Please check them out.</p>
            </div>        
        </div>
        <div className="w-full">
            <div className='flex flex-col md:flex-row px-10 gap-10'>
                {config.projects.map((project) => (
                    <a href={project.link}>
                        <div className='relative'>
                            <img className='h-[300px] w-[600px]' src={project.image}/>
                            <div className='project-desc'>
                                <p className='text-center px-5 py-5'>{project.description}</p>
                                <div className='flex justify-center'>
                                    <a className='btn' target='_blank' href={project.link}>View Project</a>
                                </div>
                            </div>
                        </div>
                    </a>
                ))}
                

            </div>
        </div>
    </section>
}